/* global $ */
import { createApp, defineAsyncComponent } from 'vue';
import { initSentry } from './sentry';
import { modalPlugin, modalService } from './plugins/modal';
import './plugins/modal.css';

// Vue3-treeselect CSS - imported early so custom styles in app.scss can override
import '@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css';

import './bootstrap';

import 'slick-carousel';
import 'chosen-js/chosen.jquery.min';
import 'vue-select/dist/vue-select.css';

import ApiClient from './api/client';
import VSelect from 'vue-select';

import LoginPopup from './components/Modals/LoginPopupComponent.vue';
import RegistrationModal from './components/Modals/RegistrationModalComponent.vue';
import AdsList from './components/AdsListComponent.vue';

const GlobalNavbarComponent = defineAsyncComponent(() => import('./components/GlobalNavbarComponent.vue'));
const AjaxTester = defineAsyncComponent(() => import('./components/AjaxTesterComponent.vue'));
const ProfessionalsList = defineAsyncComponent(() => import('./components/ProfessionalListComponent.vue'));
const ProfessionalsListEntry = defineAsyncComponent(() => import('./components/ProfessionalListEntryComponent.vue'));

const AdsListEntry = defineAsyncComponent(() => import('./components/AdsListEntryComponent.vue'));
const BusinessAdsList = defineAsyncComponent(() => import('./components/BusinessAdsListComponent.vue'));
const BusinessAdsListEntry = defineAsyncComponent(() => import('./components/BusinessAdsListEntryComponent.vue'));
const MastersList = defineAsyncComponent(() => import('./components/MastersListComponent.vue'));
const MastersListEntry = defineAsyncComponent(() => import('./components/MastersListEntryComponent.vue'));
const MastersApplicationEntry = defineAsyncComponent(() => import('./components/MastersApplicationEntryComponent.vue'));
const ApplicationsList = defineAsyncComponent(() => import('./components/ApplicationsListComponent.vue'));
const ApplicationsListEntry = defineAsyncComponent(() => import('./components/ApplicationsListEntryComponent.vue'));
const Stars = defineAsyncComponent(() => import('./components/StarsComponent.vue'));
const ComponentAddress = defineAsyncComponent(() => import('./components/ComponentAddress.vue'));
const AddressGoogleAutocomplete = defineAsyncComponent(() => import('./components/AddressGoogleAutocompleteComponent.vue'));
const AdsStatusButton = defineAsyncComponent(() => import('./components/AdsStatusButtonComponent.vue'));
const MenuSignupButton = defineAsyncComponent(() => import('./components/MenuSignupButtonComponent.vue'));
const SignupButton = defineAsyncComponent(() => import('./components/SignupButtonComponent.vue'));
const NotLoggedApplicationButtons = defineAsyncComponent(() => import('./components/NotLoggedApplicationButtons.vue'));
const LoggedApplicationButton = defineAsyncComponent(() => import('./components/LoggedApplicationButton.vue'));
const BusinessCreateAd = defineAsyncComponent(() => import('./components/Forms/BusinessCreateAd.vue'));
const BusinessEditForm = defineAsyncComponent(() => import('./components/Forms/BusinessEditForm.vue'));
const BusinessProfile = defineAsyncComponent(() => import('./components/Forms/BusinessProfile.vue'));
const ProfessionalProfile = defineAsyncComponent(() => import('./components/Forms/ProfessionalProfile.vue'));

const DeleteConfirmationModal = defineAsyncComponent(() => import('./components/Modals/DeleteConfirmationModalComponent.vue'));
const AdminAdApprovalModal = defineAsyncComponent(() => import('./components/Modals/AdminAdApprovalModalComponentNew.vue'));
const AdminDescriptionApprovalModal = defineAsyncComponent(() => import('./components/Modals/AdminDescriptionApprovalModalComponent.vue'));

const AddNewLocation = defineAsyncComponent(() => import('./components/Modals/LocationCreateNewModalComponent.vue'));

const AddNewContact = defineAsyncComponent(() => import('./components/Modals/ContactCreateNewModalComponent.vue'));

const OpenRegistrationModal = defineAsyncComponent(() => import('./components/OpenRegistrationModalComponent.vue'));

const SaveActionPopupComponent = defineAsyncComponent(() => import('./components/Modals/SaveActionPopupComponent.vue'));
const AdActionPopupComponent = defineAsyncComponent(() => import('./components/Modals/AdActionPopupComponent.vue'));
const AdApplicationComponent = defineAsyncComponent(() => import('./components/Modals/AdApplicationComponent.vue'));
const AdSavePopupComponent = defineAsyncComponent(() => import('./components/Modals/AdSavePopupComponent.vue'));

const ProfessionalViewPopupComponent = defineAsyncComponent(() => import('./components/Modals/ProfessionalViewModalComponent.vue'));

import ComponentSearchAd from './components/ComponentSearchAd.vue';

const AdApplicationsListComponent = defineAsyncComponent(() => import('./components/AdApplicationsListComponent.vue'));
const AdApplicationsListEntryComponent = defineAsyncComponent(() => import('./components/AdApplicationsListEntryComponent.vue'));

const BusinessDetailsComponent = defineAsyncComponent(() => import('./components/BusinessDetailsComponent.vue'));

const HomePageHeroBannerComponent = defineAsyncComponent(() => import('./components/Home/HomePageHeroBannerComponent.vue'));
const HomeAdsListComponent = defineAsyncComponent(() => import('./components/Home/HomeAdsListComponent.vue'));
const HomeProfessionalsListComponent = defineAsyncComponent(() => import('./components/Home/HomeProfessionalsListComponent.vue'));

const LoginPageComponent = defineAsyncComponent(() => import('./components/LoginPageComponent.vue'));
const ForgotPasswordComponent = defineAsyncComponent(() => import('./components/Auth/ForgotPasswordComponent.vue'));
const ResetPasswordComponent = defineAsyncComponent(() => import('./components/Auth/ResetPasswordComponent.vue'));
const ReconsentPageComponent = defineAsyncComponent(() => import('./components/Auth/ReconsentPageComponent.vue'));

const BusinessAdminDetailsComponent = defineAsyncComponent(() => import('./components/BusinessAdminDetailsComponent.vue'));

const BusinessList = defineAsyncComponent(() => import('./components/BusinessListComponent.vue'));
const BusinessListEntry = defineAsyncComponent(() => import('./components/BusinessListEntryComponent.vue'));

const SubscriptionSuccessPopupComponent = defineAsyncComponent(() => import('./components/Modals/SubscriptionSuccessPopupComponent.vue'));

$(function () {
    /*
    $('[data-bs-toggle="tooltip"]').tooltip({
        html: true,
        trigger: 'click,hover',
    });
    */
});

$.fn.toJSON = function(options){

    options = $.extend({}, options);

    var self = this,
        json = {},
        push_counters = {},
        patterns = {
        "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
        "key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
        "push":     /^$/,
        "fixed":    /^\d+$/,
        "named":    /^[a-zA-Z0-9_]+$/
        };


    this.build = function(base, key, value){
        base[key] = value;
        return base;
    };

    this.push_counter = function(key){
        if(push_counters[key] === undefined){
        push_counters[key] = 0;
        }
        return push_counters[key]++;
    };

    $.each($(this).serializeArray(), function(){

        if(!patterns.validate.test(this.name)){
        return;
        }

        var k,
        keys = this.name.match(patterns.key),
        merge = this.value,
        reverse_key = this.name;

        while((k = keys.pop()) !== undefined){

        reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

        if(k.match(patterns.push)){
            merge = self.build([], self.push_counter(reverse_key), merge);
        }

        else if(k.match(patterns.fixed)){
            merge = self.build([], k, merge);
        }

        else if(k.match(patterns.named)){
            merge = self.build({}, k, merge);
        }
        }

        json = $.extend(true, json, merge);
    });

    return json;
};

const legacyVue = window.Vue || {};
const apiClient = new ApiClient();
legacyVue.apiClient = apiClient;
legacyVue.$modal = modalService;
window.Vue = legacyVue;

const app = createApp({
    beforeMount() {
        console.log('Vue app before mount');
    },
    mounted() {
        setTimeout(() => {
            document.documentElement.classList.add('page-dom-loaded');
        }, 1500);

        const pageLoading = document.querySelector('.page-loading');
        if (pageLoading) {
            pageLoading.style.display = 'none';
        }

        const pageLoadingCSS = document.querySelector('.page-loading-css ');
        if (pageLoadingCSS) {

            const ball = document.querySelector('.page-loading-css .loading-ball');

            if ( ball ) {
                ball.addEventListener('animationend', () => {
                    console.log('Animation finished!');
                    pageLoadingCSS.style.display = 'none';

                });
            }



        }

        document.querySelectorAll('link.defer-css[rel="preload"][as="style"]').forEach(link => {
            const href = link.getAttribute('href');
            if (href) {
                const styleLink = document.createElement('link');
                styleLink.rel = 'stylesheet';
                styleLink.href = href;
                link.parentNode.insertBefore(styleLink, link.nextSibling);
                link.remove();
            }
        });

    }
});

const components = [
    ['global-navbar', GlobalNavbarComponent],
    ['v-select', VSelect],
    ['ajax-tester', AjaxTester],
    ['professionals-list', ProfessionalsList],
    ['professionals-list-entry', ProfessionalsListEntry],
    ['ads-list', AdsList],
    ['ads-list-entry', AdsListEntry],
    ['business-ads-list', BusinessAdsList],
    ['business-ads-list-entry', BusinessAdsListEntry],
    ['masters-list', MastersList],
    ['masters-list-entry', MastersListEntry],
    ['masters-application-entry', MastersApplicationEntry],
    ['applications-list', ApplicationsList],
    ['applications-list-entry', ApplicationsListEntry],
    ['stars', Stars],
    ['requests-search-google-autocomplete', ComponentAddress],
    ['address-google-autocomplete', AddressGoogleAutocomplete],
    ['ads-status-button', AdsStatusButton],
    ['menu-signup-button', MenuSignupButton],
    ['signup-button', SignupButton],
    ['not-logged-application-buttons', NotLoggedApplicationButtons],
    ['logged-application-button', LoggedApplicationButton],
    ['new-ads-form', BusinessCreateAd],
    ['business-edit-form', BusinessEditForm],
    ['business-profile-form', BusinessProfile],
    ['professional-edit-form', ProfessionalProfile],
    ['login-popup', LoginPopup],
    ['registration-modal', RegistrationModal],
    ['delete-confirmation-modal', DeleteConfirmationModal],
    ['admin-ad-approval-modal', AdminAdApprovalModal],
    ['admin-description-approval-modal', AdminDescriptionApprovalModal],
    ['add-new-location', AddNewLocation],
    ['add-new-contact', AddNewContact],
    ['open-registration-modal', OpenRegistrationModal],
    ['search-ad-filters', ComponentSearchAd],
    ['save-action-modal', SaveActionPopupComponent],
    ['ad-action-modal', AdActionPopupComponent],
    ['ad-application-modal', AdApplicationComponent],
    ['ad-save-modal', AdSavePopupComponent],
    ['ad-applications-list', AdApplicationsListComponent],
    ['ad-applications-list-entry', AdApplicationsListEntryComponent],
    ['professional-view-modal', ProfessionalViewPopupComponent],
    ['business-details', BusinessDetailsComponent],
    ['home-hero-banner', HomePageHeroBannerComponent],
    ['home-ads-list', HomeAdsListComponent],
    ['home-professional-list', HomeProfessionalsListComponent],
    ['login-page', LoginPageComponent],
    ['forgot-password-component', ForgotPasswordComponent],
    ['reset-password-component', ResetPasswordComponent],
    ['reconsent-page-component', ReconsentPageComponent],
    ['business-admin-details', BusinessAdminDetailsComponent],
    ['business-list', BusinessList],
    ['business-list-entry', BusinessListEntry],
    ['subscription-action-modal', SubscriptionSuccessPopupComponent],
];

components.forEach(([name, component]) => {
    app.component(name, component);
});

app.use(modalPlugin);

app.config.globalProperties.$apiClient = apiClient;
app.config.globalProperties.$checkTermsText = `Accetto i <a target="_blaknk" href="https://www.iubenda.com/termini-e-condizioni/97894394" class="iubenda-nostyle no-brand iubenda-embed" title="Termini e Condizioni">termini e le condizioni</a> e <a target="_blank" href="https://www.iubenda.com/privacy-policy/97894394" class="iubenda-nostyle iubenda-embed " title="Privacy Policy">l'informativa per la privacy</a> `;
app.config.globalProperties.$checkPromoText = `Desidero rimanere aggiornato e ricevere comunicazioni informative e commerciali riguardo le novità della piattaforma TennisPadelJobs ( <b>consigliato!</b> ), secondo la nostra`;
app.config.globalProperties.$checkThirdText = `Accetto la comunicazione dei miei dati personali a terzi per l'invio di materiale promozionale inerente al mondo del Tennis e Padel`;

legacyVue.$modal = modalService;
legacyVue.apiClient = apiClient;

initSentry(app);

const vm = app.mount('#top-section-site');

window.vueApp = vm;

// ============================================================================
// Slick Carousel Fallback Initialization
// ============================================================================
// During Vue 3 migration, there's a conflict between static jQuery/Slick loading
// (in footer-script.blade.php) and Vite-bundled versions. The static slick.min.js
// binds $(document).on('ready'), but Vite's bootstrap.js may overwrite jQuery,
// causing the ready event to never fire. This fallback re-initializes any
// uninitialized sliders after Vue has mounted.
// ============================================================================
setTimeout(() => {
    if (typeof $ !== 'undefined' && $.fn.slick) {
        // Reviews/Testimonials carousel - homepage
        const $reviewsCarousel = $('#reviews-carousel');
        if ($reviewsCarousel.length && !$reviewsCarousel.hasClass('slick-initialized')) {
            console.log('[Slick Fallback] Initializing #reviews-carousel');
            
            // Add slide gap styling dynamically
            const style = document.createElement('style');
            style.textContent = `
                #reviews-carousel .slick-slide { padding: 0 15px; }
                #reviews-carousel .slick-list { margin: 0 -15px; }
                #reviews-carousel .slick-prev { left: -120px; }
                #reviews-carousel .slick-next { right: -120px; }
            `;
            document.head.appendChild(style);
            
            $reviewsCarousel.slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,  // Enable arrow navigation
                autoplay: true,
                slide: 'div',
                fade: false,
                infinite: true,
                dots: true,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Precedente"><i class="la la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Successivo"><i class="la la-angle-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            vertical: false,
                            centerMode: true,
                            centerPadding: '0px',
                            dots: true
                        }
                    }
                ]
            });
        }
    }
}, 150); // Small delay to ensure DOM is ready after Vue mount

